export default {
  goal: [],
  workspace: [],
  meetingItem: [],
  comment: [],
  user: [],
};
